<div class="SLV-no-content-box">
    <img src="selflearnv2-ui/assets/img/self-learn-v2/empty-avater.svg" class="no-content-avatar" />
    <h3 class="no-content-hdng">Oops! Nothing here...</h3>
    <h4 class="no-content-text">We couldn't find any content for this chapter for <br>the moment. Please visit after sometime.</h4>
    <button class="blue-text-button" (click)="navigateToViewAllVideosList()">Watch trending videos</button>
</div>
